import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ProductoOtComponent } from './producto-ot.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgxPermissionsModule } from 'ngx-permissions';
import { MaterialModule } from '../../../components/material/material.module';
import { NgSelectModule } from '@ng-select/ng-select';
import { ComunicacionService } from '../../../providers/comunicacion.service';
import { ProductoService } from '../../../providers/producto.service';
import { CaracteristicasModule } from '../../../components/productos/caracteristicas/caracteristicas.module';
import { MaterialFileInputModule } from 'ngx-material-file-input';
import { TablaProductoOtComponent } from './tabla-producto-ot/tabla-producto-ot.component';
import { PipesModule } from '../../../pipes/pipes.module';
import { ArchivoModule } from '../../../components/archivo/archivo.module';
import { AccesorioService } from '../../../providers/accesorio.service';

@NgModule({
  imports: [
    CommonModule,
    NgxPermissionsModule.forChild(),
    MaterialModule,
    ReactiveFormsModule,
    FormsModule,
    NgSelectModule,
    CaracteristicasModule,
    MaterialFileInputModule,
    PipesModule,
    ArchivoModule,
  ],
  declarations: [
    ProductoOtComponent,
    TablaProductoOtComponent,
  ],
  providers: [
    ProductoService,
    ComunicacionService,
    AccesorioService,
  ],
  entryComponents: [
    ProductoOtComponent
  ],
  exports: [
    ProductoOtComponent,
    TablaProductoOtComponent,
  ]
})
export class ProductoOtModule { }
